import { Flex, Typography } from "antd";
import React from "react";

type PageTitleProps = {
  children: React.ReactNode;
};

export const PageTitle = (props: PageTitleProps) => {
  const { children } = props;

  return <Typography.Title level={3}>{children}</Typography.Title>;
};

type PageTitleContainerProps = PageTitleProps & {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  extra?: React.ReactNode;
};

export const PageTitleContainer = (props: PageTitleContainerProps) => {
  const { children, title, subtitle, extra } = props;
  return (
    <Flex vertical gap={24}>
      <Flex justify="space-between" align="end">
        <Flex vertical>
          <PageTitle>{title}</PageTitle>
          {subtitle ? (
            <Typography.Text style={{ margin: 0 }}>{subtitle}</Typography.Text>
          ) : null}
        </Flex>
        {extra}
      </Flex>
      {children}
    </Flex>
  );
};
